
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'sas-checkbox-field-type',
    standalone: true,
    imports: [ReactiveFormsModule, FormlyModule, TranslateModule],
    providers: [],
    template: `
        <label class="sas-checkbox mb-3" [for]="instanceId">
            <input type="checkbox"
                   [id]="instanceId"
                   [name]="field.name"
                   [formControl]="formControl"
                   class="form-check-input check"
                   [attr.aria-describedby]="helpText ? instanceId + 'Desc' : ''"
                   [attr.aria-invalid]="field.formControl.invalid || null"
                   [attr.aria-required]="field.props.required || null"
                   (keydown)="onKeydown($event)"
            />
            <span [id]="instanceId + 'Label'"
                  class="form-check-label"
                  translate="{{ field.props.label }}"
                  title="{{ field.props.label ?? '' | translate }}">
            </span>
            @if (helpText?.length) {
            <div [id]="instanceId + 'Desc'" class="sas-inline-block" [title]="helpText">
                <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
            </div>
            }
        </label>
    `,
    styleUrl: './sas-checkbox-field-type.component.scss'
})

export class SasCheckboxFieldTypeComponent extends FieldType<FieldTypeConfig> {
    private translate = inject(TranslateService);

    instanceId: string = '';
    helpText!: string;

    constructor() {
        super()
    }

    ngOnInit() {
        this.instanceId = this.field.id + Math.random().toString(36).substring(2);

        if (this.field.props['helptext']) {
            const helpText = this.translate.instant(this.field.props['helptext']);

            this.helpText = helpText === this.field.props['helptext'] ? '' : helpText;
        }
    }

    onKeydown(event: KeyboardEvent) {
        if (event.code === 'Enter' || event.key === 'Enter') {
            event.preventDefault();
            if (!this.field.formControl.disabled) {
                this.formControl.setValue(!this.formControl.value);
            }
        }
    }
}
